import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=modern%20cinema%20theater%20interior%20with%20glowing%20screen%20displaying%20vibrant%20colorful%20abstract%20visuals%2C%20luxurious%20red%20seats%2C%20dramatic%20atmospheric%20lighting%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20cinematic%20composition%2C%20elegant%20entertainment%20venue%2C%20immersive%20viewing%20experience&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="91视频网站 - 高清视频在线观看平台"
        title="91视频网站高清视频在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/60"></div>
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
          {t('home.heroTitle')}
        </h2>
        <p className="mt-4 md:mt-5 max-w-2xl mx-auto text-sm md:text-base text-background-200 leading-relaxed">
          {t('home.heroSubtitle')}
        </p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/category/all"
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-1.5"></i>
            {t('home.heroCTA')}
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/25 hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('home.heroSecondary')}
          </Link>
        </div>
        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">10万+</p>
            <p className="text-xs md:text-sm text-background-400 mt-1">视频资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5000万+</p>
            <p className="text-xs md:text-sm text-background-400 mt-1">活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">4.9</p>
            <p className="text-xs md:text-sm text-background-400 mt-1">用户评分</p>
          </div>
        </div>
      </div>
    </section>
  );
}